import {
  COLOR_INDICATORS,
  SEARCH_INDICATORS_COLUMN_ENABLE,
} from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getConstanceSetting } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

// Two independent gates: COLOR_INDICATORS is the account-level indicators
// feature, SEARCH_INDICATORS_COLUMN_ENABLE hides the column while the project
// is in progress and is removed once it ships.
export const useIndicatorsEnabled = (): boolean => {
  const colorIndicatorsEnabled = useFeatureEnabled(COLOR_INDICATORS)
  const indicatorsColumnEnabled = Boolean(
    useSelector(state =>
      getConstanceSetting(state, SEARCH_INDICATORS_COLUMN_ENABLE),
    ),
  )

  return colorIndicatorsEnabled && indicatorsColumnEnabled
}
